module.exports = __webpack_public_path__ + "static/present-f7ef46fd93240c03f0aff43ae592904c.png";